import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { objectType } from '../../../../../../../../../constants/proptype-validation';

export default class extends PureComponent {

  static displayName = 'ReactSelectOption';

  constructor() {
    super();
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
  }

  static get propTypes() {
    return {
      children: PropTypes.node,
      className: PropTypes.string,
      instancePrefix: PropTypes.string.isRequired,
      isDisabled: PropTypes.bool,
      isFocused: PropTypes.bool,
      isSelected: PropTypes.bool,
      isSort: PropTypes.bool,
      onFocus: PropTypes.func,
      onSelect: PropTypes.func,
      onUnfocus: PropTypes.func,
      option: objectType.isRequired,
      optionIndex: PropTypes.number,
    };
  }

  handleMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  }

  handleMouseEnter(event) {
    this.onFocus(event);
  }

  onFocus(event) {
    if (!this.props.isFocused) {
      this.props.onFocus(this.props.option, event);
    }
  }

  renderComponent() {
    const { option, instancePrefix, optionIndex } = this.props;
    const optionClassName = classNames(this.props.className, {
      'Select-option-special': option.isSpecial,
    }, option.className);
    const labelClassName = classNames('Select-option-label', {
      'Select-option-label__no-description': !option.description,
    });

    if (option.disabled) {
      return (
        <div className={optionClassName}>
          {option.disableTitle}
        </div>
      );
    } else {
      return (
        <div className={optionClassName}
          style={option.style}
          role="option"
          onMouseDown={this.handleMouseDown}
          onMouseEnter={this.handleMouseEnter}
          id={`${instancePrefix} -option- ${optionIndex}`
          }
        >
          {
            option.withCheckbox
              ? <div className="Select-option-check">
                <input type="checkbox" checked={option.isSelected} onChange={() => { }} />
              </div>
              : null
          }
          {
            option.hideTitle
              ? null
              : <div title={option.label} className={labelClassName}>
                {option.label}
              </div>
          }
          {
            option.description
              ? <div className="Select-option-description" title={option.description}>
                {option.description}
              </div>
              : null
          }
          {
            option.isSelected && option.typeLabel
              ? <div className="Select-option-type">({option.typeLabel})</div>
              : null
          }
        </div >
      );
    }
  }

  render() {
    return this.renderComponent();
  }
}
